import { createElement } from 'react';
import { createRoot } from 'react-dom/client';

import { ErrorScreen } from '../../components/error-screen';

// Store the root instance
let root: ReturnType<typeof createRoot> | null = null;

export function showErrorScreen() {
  const { document } = window;
  if (document == null) {
    return;
  }
  const loadingScreen = document.querySelector('#loading-screen-blym') as HTMLElement;
  if (loadingScreen == null) {
    return;
  }

  loadingScreen.classList.remove('pointer-events-none');

  // Unmount existing root if it exists
  if (root !== null) {
    root.unmount();
    root = null;
  }

  // Create a new root
  root = createRoot(loadingScreen);

  // Render using the new root
  root.render(createElement(ErrorScreen));
}
